import React from "react";
import { slideInRight } from "react-animations";
import Radium, { StyleRoot } from "radium";

const styles = {
  bounce: {
    animation: "1s",
    animationName: Radium.keyframes(slideInRight, "slideInRight"),
  },
};

const Animation = ({ children }) => {
  return (
    <StyleRoot>
      <div className="animation" style={styles.bounce}>
        {children}
      </div>
    </StyleRoot>
  );
};

export default Animation;
